// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#delete_modal .modal-body {
  padding: 60px !important;
}

.DeleteModal .ant-modal-wrap {
  z-index: 1002 !important;
}
`, "",{"version":3,"sources":["webpack://./src/commons/DeleteModal/DeleteModal.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["#delete_modal .modal-body {\n  padding: 60px !important;\n}\n\n.DeleteModal .ant-modal-wrap {\n  z-index: 1002 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
